import ClientForm from './ClientForm.vue';

export default ClientForm;
